import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { MessagingService } from 'src/app/services/messaging.service';
import { ToastrService } from 'ngx-toastr';
import { FilteringService } from 'src/app/services/filtering.service';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { ApplicantDataService } from 'src/app/services/applicant-data.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MessagingStatLog } from 'src/app/models/MessagingStatLog';
import { tap } from 'rxjs/operators';
import { EmailErrorDialogComponent } from '../email-error-dialog/email-error-dialog.component';

@Component({
  selector: 'app-screening-emails',
  templateUrl: './screening-emails.component.html',
  styleUrls: ['./screening-emails.component.less']
})
export class ScreeningEmailsComponent implements OnInit,OnDestroy {
  @Input() reportId: number;
  emailsub$: Subscription;
  _logs : MessagingStatLog[];
  hidden: boolean = false;

  constructor(public mess: MessagingService, 
    public toast: ToastrService, 
    public filtering: FilteringService, 
    public router: Router,
    public auth: AuthService,
    public appData : ApplicantDataService,
    public modalService: NgbModal) {}

  ngOnDestroy(): void {
    try {
      this.emailsub$.unsubscribe();
    } catch (error) {
      
    }
  }
  ngOnInit(): void {
    this.emailsub$ = this.mess.fetchEmailErrorLogsSingleReport(this.reportId).pipe(tap((_: MessagingStatLog[]) => {
      this._logs = _;
    },
    e => {
      this.toast.error('Error fetching email logs', '', { closeButton: true, disableTimeOut: true });
    },
    () => {})).subscribe();
  }

  public show() {
    this.hidden = !this.hidden;
  }

  public resolveErrorDialog(err: MessagingStatLog) {
    let mod = this.modalService.open(EmailErrorDialogComponent, { centered: true, size: 'lg' });
    mod.componentInstance.datas = err;
    mod.componentInstance.name = 'ResolveEmailErrorDialog';
    mod.componentInstance.emailResolved.subscribe((_ : MessagingStatLog)=>{
      // err = _;
      Object.assign(err,_);
    });

  }


}
